export default __webpack_public_path__ + "static/media/Factors-responsible.12c41a7f.jpg";